import { useSelector } from 'react-redux';
import map from 'lodash/map';

export function useAuditLogs(resourceType, id) {
  const auditLog = useSelector((state: any) => state.entities.auditLog);
  const byKey = useSelector((state: any) => state.auditLog.byKey);

  if (!resourceType || !id) {
    return [];
  }

  let auditItems = [];

  if (byKey[`${resourceType}${id}`]) {
    auditItems = byKey[`${resourceType}${id}`];
  }

  return map(auditItems, (i) => auditLog[i]);
}
